import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { pipe, split, ifElse, compose, equals, length, filter, addIndex, map, isEmpty, complement, trim } from 'ramda';

import { List, RowText, RowItem, Text } from './experienceSectionList.styles';

const SPLIT_CHAR = '- ';
const breakAtTheEndOfLineRegex = /(\r\n|\n|\r)$/gm;

export class ExperienceSectionList extends PureComponent {
  static propTypes = {
    text: PropTypes.string,
    className: PropTypes.any,
  };

  static defaultProps = {
    text: '',
  };

  renderText = () => (
    <RowText className={this.props.className}>{this.props.text.replace(breakAtTheEndOfLineRegex, '')}</RowText>
  );

  renderList = list =>
    pipe(
      filter(
        compose(
          complement(isEmpty),
          trim
        )
      ),
      addIndex(map)((text, index) => (
        <RowItem key={index}>
          <Text>{text.replace(breakAtTheEndOfLineRegex, '')}</Text>
        </RowItem>
      )),
      items => (
        <List className={this.props.className} oneItem={items.length === 1}>
          {items}
        </List>
      )
    )(list);

  renderContent = () =>
    pipe(
      split(SPLIT_CHAR),
      ifElse(
        compose(
          equals(1),
          length
        ),
        this.renderText,
        this.renderList
      )
    )(this.props.text);

  render() {
    return this.renderContent();
  }
}
